import React from 'react';

const ErrorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
    <path
      fill="#AB0000"
      fill-rule="evenodd"
      d="M8 .94a7.06 7.06 0 1 0 0 14.12A7.06 7.06 0 0 0 8 .94Zm-5.66 1.4a8 8 0 1 1 11.32 11.32A8 8 0 0 1 2.34 2.34ZM6 6a.47.47 0 0 1 .67 0L8 7.33 9.34 6a.47.47 0 0 1 .67.67L8.67 8 10 9.34a.47.47 0 0 1-.67.67L8 8.67 6.66 10a.47.47 0 0 1-.67-.67L7.33 8 6 6.66a.47.47 0 0 1 0-.67Z"
      clip-rule="evenodd"
    />
  </svg>
);

export default ErrorIcon;
